import React from 'react'
import { Route } from 'react-router-dom'
import { SigninMethodList } from './page/signin-method-list'

export const LayoutSigninMethod = () => {
  return (
    <React.Fragment>
      <Route path="/admin/signin-method" component={SigninMethodList} />
    </React.Fragment>
  )
}
